import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "./features/user/userSlice";
// import user from "./features/user/userSlice";
import billerSlice from "./features/billers/billerSlice";
import billerDetailSlice from "./features/billerDetails/billerDetailSlice";
import categoryOptionsSlice from "./features/categoryOptions/categoryOptionSlice";
import refIdsSlice from "./features/categoryOptions/refIdsSlice";

const rootReducer = combineReducers({
  user: userSlice,
  billers: billerSlice,
  billerDetails: billerDetailSlice,
  categoryOptions: categoryOptionsSlice,
  refIds: refIdsSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;

// export type RootState = ReturnType<typeof rootReducer>;
